import { useGetPaymentStatsAggregateQuery } from '../graphql'
import { makeQueryWithReducer } from '../utils'
import { PaymentStatsParser } from './validations'

export const useGetPaymentStatsAggregateQueryWithReducer = makeQueryWithReducer(
  useGetPaymentStatsAggregateQuery,
  (result) => PaymentStatsParser.parse(result.data?.PaymentStats),
)
